import * as React from "react";

import "./information.scss";

import {cs} from "@Common/react/chain-services";

import {groupEnrollmentEditors} from "@Xpresso/routes/account/common/scheduled-campaigns-panel/common/group-enrollment-editors";

import {AgentDisplayFields}  from "./agent-display-fields/agent-display-fields";
import {ReturnAddressFields} from "./return-address-fields/return-address-fields";

export const Information = ({initEnrollment, program, agentId, next}) => cs(
    ["agentDisplayFields", (_, next) => AgentDisplayFields({initEnrollment, agentId, next})],
    ["returnAddressFields", (_, next) => ReturnAddressFields({initEnrollment, program, next})],
    ({agentDisplayFields, returnAddressFields}) => next({
        enrollmentEditor: groupEnrollmentEditors([
            agentDisplayFields .enrollmentEditor,
            returnAddressFields.enrollmentEditor,
        ]),
        getValue: () => ({
            agentDisplayFields: agentDisplayFields.getValue(),
            returnAddressFields: returnAddressFields.getValue(),
        }),
        render: ({}) => (
            <div {...{
                className: "information-72k",
                "xd-qa-type": "card",
                "xd-qa-name": "Contact information",
            }}>
                <div className="header">

                    <div {...{
                        className: "title",

                        "xd-qa-type": "label",
                        "xd-qa-name": "Contact information",
                    }}>
                        Confirm your contact information to include on each piece:
                    </div>

                    <div className="right">
                        <button {...{
                            onClick: () => agentDisplayFields.resetToDefault(),
                            "xd-qa-type": "button",
                            "xd-qa-name": "RESET TO DEFAULT",
                        }}>
                            RESET TO DEFAULT
                        </button>
                    </div>
                </div>

                <div className="box">
                    {agentDisplayFields.render({})}
                </div>
                <div className="box">
                    {returnAddressFields.render({})}
                </div>
            </div>
        ),
    }),
);

